// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var logout_success = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict._0, "logout_success"), null));
  if (logout_success.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              logout_success: logout_success._0
            }
          };
  }
  var e = logout_success._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".logout_success" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  t_decode ,
}
/* No side effect */
